import React, { useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, FormFeedback, Label, Button } from 'reactstrap'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

// Only allow letters, numbers, spaces, dot, dash, underscore, comma
const reasonRegex = /^[a-zA-Z0-9\s.,\-_]*$/

const schema = yup.object().shape({
    reason: yup
        .string()
        .trim()
        .required('Reason is required and must be at least 5 characters.')
        .min(5, 'Reason is required and must be at least 5 characters.')
        .max(500, 'Reason must be at most 500 characters.')
        .test(
            'max-words',
            'Reason must be at most 100 words.',
            value => !value || value.trim().split(/\s+/).length <= 100
        )
        .matches(reasonRegex, 'Only letters, numbers, spaces, dot, dash, underscore, and comma are allowed.'),
})

const ArchiveReasonModal = ({ isOpen, isArchived, onCancel, onContinue }) => {
    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
    })

    useEffect(() => {
        if (!isOpen) {
            reset()
        }
    }, [isOpen, reset])

    const onSubmit = (data) => {
        if (!isArchived) {
            onContinue(data.reason.trim())
        } else {
            onContinue()
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={onCancel}>
            <ModalHeader>{isArchived ? "Un-Archive Incident" : "Archive Incident"}</ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody>
                    {!isArchived && (
                        <FormGroup>
                            <Label for="archiveReason">
                                Please provide a reason for archiving this incident:
                            </Label>
                            <Controller
                                name="reason"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                    <Input
                                        id="archiveReason"
                                        type="textarea"
                                        value={value}
                                        onChange={onChange}
                                        invalid={!!errors.reason}
                                        placeholder="Enter reason..."
                                        autoFocus
                                        maxLength={500}
                                    />
                                )}
                            />
                            {errors.reason && (
                                <FormFeedback>{errors.reason.message}</FormFeedback>
                            )}
                        </FormGroup>
                    )}
                    {isArchived && (
                        <div>This will un-archive the incident. No reason required.</div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={onCancel} type="button">Cancel</Button>
                    <Button color={"warning"} type="submit">
                        Continue
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default ArchiveReasonModal
